// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.d9f713f2b.chunk.js";
	if (chunkId === 12) return "static/js/profiler.d9f713f2b.chunk.js";
	if (chunkId === 31) return "static/js/31.d9f713f2b.chunk.js";
	if (chunkId === 625) return "static/js/625.d9f713f2b.chunk.js";
	if (chunkId === 160) return "static/js/160.d9f713f2b.chunk.js";
	if (chunkId === 103) return "static/js/103.d9f713f2b.chunk.js";
	if (chunkId === 177) return "static/js/177.d9f713f2b.chunk.js";
	// return url for filenames based on template
	return undefined;
};